import { render } from "./MailTypesView.vue?vue&type=template&id=e9b876f8&scoped=true"
import script from "./MailTypesView.vue?vue&type=script&lang=js"
export * from "./MailTypesView.vue?vue&type=script&lang=js"

import "./MailTypesView.vue?vue&type=style&index=0&id=e9b876f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9b876f8"]])

export default __exports__